export default __webpack_public_path__ + "static/media/943.5abf0b2a.gif";